import { Component, Input, ViewChild, Renderer2, ViewEncapsulation } from "@angular/core";
import { saveAs } from '@progress/kendo-file-saver';
import { PersonTrainingBus } from "../../shared/models/PersonTrainingBus";
import { UntypedFormGroup, UntypedFormControl, Validators } from "@angular/forms";
import { GridComponent } from "@progress/kendo-angular-grid";
import { EmployeeService } from "../../shared/services/employee.service";
import { FileInfo } from '@progress/kendo-angular-upload';
import { CDocument } from "../../shared/models/CDocument";
import { DomSanitizer } from "@angular/platform-browser";
import { Subscription } from "rxjs";
import { GItem } from "../../shared/models/GItem";
import { BaseAppMComponent } from "../../shared/base-components/base-app-m.component";
import { DQOIReferenceDataQuery } from "../../dqoi/state/dqoi-reference-data.query";
import { GlobalsService } from "../../shared/services/globals.service";
import { CommonValues } from "../../shared/static/CommonValues";
import { CRUDActions } from "../../shared/enums/CRUDActions";
import { CPDialogResult } from "../../shared/enums/CPDialogResult";
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

const createFormGroup = dataItem => new UntypedFormGroup({
    'personTrainingId': new UntypedFormControl(dataItem.personTrainingId || ''),
    'updateDt': new UntypedFormControl(dataItem.updateDt || new Date()),
    'trainingCategoryId': new UntypedFormControl(dataItem.trainingCategoryId || ''),
    'note': new UntypedFormControl(dataItem.note || ''),
    'attachmentDetailFullName': new UntypedFormControl(dataItem.attachmentDetailFullName || ''),
    'fileUpload': new UntypedFormControl(dataItem.attachmentDetailFullName || ''),
});

const hasClass = (el, className) => new RegExp(className).test(el.className);

const isChildOf = (el, className) => {
    while (el && el.parentElement) {
        if (hasClass(el.parentElement, className)) {
            return true;
        }
        el = el.parentElement;
    }
    return false;
};

@Component({
    selector: 'employee-training',
    templateUrl: './employee-training.component.html',
    styleUrls: ['./employee-training.component.scss'],
    encapsulation: ViewEncapsulation.None,
    styles: [`
  .k-widget.k-upload .k-action-buttons {
    display: none;
  }
`],
    standalone: false
})
export class EmployeeTrainingComponent extends BaseAppMComponent<null, EmployeeService, null, null> {
    dataLoading: boolean = false;
    updateTraining: boolean = false;
    public employeeTrainingForm: UntypedFormGroup;
    private isNew: boolean;
    @Input() personId: string = '00000000-0000-0000-0000-000000000000';
    @Input() readOnly: boolean = false;
    @ViewChild(GridComponent) private grid: GridComponent;
    private editedRowIndex: number;
    documentData: any = "";
    documentDataURL: any;
    document: CDocument;
    viewingDocument: boolean = false;
    subs_data_ref: Subscription;
    public trainingCategorys: GItem[] = [];
    appCode = "Employee Training"
    constructor(
        globals: GlobalsService,
        qry_rd: DQOIReferenceDataQuery,
        featureFlagService: FeatureFlagService,
        public svc_data: EmployeeService,

        private sanitizer: DomSanitizer,
        private renderer: Renderer2) {

        super(globals, featureFlagService, qry_rd);
    }
    deleteDialog(data: PersonTrainingBus) {

        this.cnfShow(CommonValues.Message_AreYouSureYouWantToDeleteThis, CRUDActions.Delete, data);
    }
    public deleteCurrent(id: any): void {

        this.svc_data.deletePersonTraining(id).subscribe(
            data => {
                this.deleteSuccess();
                this.LoadTraining();
            },
            err => { this.CallFailed(err) });

    }
    confirmDialog(data: any) {

        let handled: boolean = false;
        if (data.dialogResult === CPDialogResult.ok) {

            this.deleteCurrent(data.data.personTrainingId);
        }
    }

    public addTraining() {
        this.employeeTrainingForm.patchValue({
            note: '',
            personTrainingId: null,
            trainingCategoryId: null,
            fileUpload: ''
        }

        )
        this.files = [];
        this.updateTraining = true;
    }
    public clickTraining({ isEdited, dataItem, rowIndex, column, columnIndex }, editClicked: boolean = false): void {
        if (columnIndex > 2) { return }

        this.employeeTrainingForm.patchValue({
            note: dataItem.note,
            trainingCategoryId: dataItem.trainingCategoryId,
            personTrainingId: dataItem.personTrainingId,
            fileUpload: ''
        }

        )
        this.files = [];
        this.updateTraining = true;

    }

    cancelUpdate(e: any) {
        this.closeUpdate();
    }
    closeUpdate() {
        this.updateTraining = false;
    }
    public TrainingCategoryDescription(trainingCategoryId: any) {
        trainingCategoryId = trainingCategoryId.toLocaleLowerCase();
        let d = this.svc_data.trainingCategories
            .find(c => c.value == trainingCategoryId);
        if (!d) {
            return "Not specified";
        }
        return d.description;
    }

    public ngOnInit(): void {
        this.subs_data_ref = this.svc_data.GetReferenceDataTraining().subscribe(data => {
            this.trainingCategorys = data.trainingCategorys
        });

        this.employeeTrainingForm = createFormGroup({
            'personTrainingId': new UntypedFormControl(''),
            'updateDt': new UntypedFormControl(''),
            'ProductName': new UntypedFormControl(''),
            'note': new UntypedFormControl(''),
            'attachmentDetailFullName': new UntypedFormControl(''),
            'trainingCategoryId': new UntypedFormControl(null, Validators.required),
            'fileUpload': ''
        });
        this.renderer.listen(
            "document",
            "click",
            ({ target }) => {
                if (!isChildOf(target, "k-grid")) {
                    this.saveClick();
                }
            });
    }

    CategorySearchFC(value : any) {

    }

    CategoryImportSearchVC(value  : any ) {

    }

    public saveClick(): void {
        if (this.employeeTrainingForm && !this.employeeTrainingForm.valid) {
            return;
        }
    }

    public saveCurrent(value: any): void {
        let busObj: PersonTrainingBus = new PersonTrainingBus();
        busObj.personTrainingId = this.employeeTrainingForm.controls['personTrainingId'].value;
        busObj.note = this.employeeTrainingForm.controls['note'].value;
        busObj.attachmentDetailFullName = '';
        busObj.personId = this.personId;
        if (busObj.personId == '00000000-0000-0000-0000-000000000000') {
            return;
        }
        let v = this.employeeTrainingForm.controls['trainingCategoryId'].value;
        busObj.trainingCategoryId = v ;
        busObj.updateDt = new Date();
        console.log("Emp-Trn: ", busObj);
        this.svc_data.saveTraining(busObj).subscribe(
            data => this.trainingSaved(data, busObj),
            err => { this.CallFailed(err) });
        this.closeUpdate();

    }

    HasAttachment(dataItem: PersonTrainingBus) {

        return dataItem
            && dataItem.attachmentDetailFullName
            && dataItem.attachmentDetailFullName.length > 0;
    }

    download(data: PersonTrainingBus) {
        this.svc_data.getDocument(data.personTrainingId).subscribe(data => {
            this.document = new CDocument(data);
            let downloadData = "data:" + this.document.mimeType + ";base64," + data.document;
            saveAs(downloadData, this.document.fileName);
        });
    }
    hide() {
        this.viewingDocument = false;
    }
    view(data: PersonTrainingBus) {
        this.svc_data.getDocument(data.personTrainingId).subscribe(data => {
            this.document = new CDocument(data);
            this.documentData = this.sanitizer.bypassSecurityTrustResourceUrl("data:" + this.document.mimeType + ";base64," + data.documentB64String); //"data:application/pdf;base64," +data.documentB64String); //"data:application/pdf;base64," + data.document);

            var binary = atob(data.documentB64String.replace(/\s/g, ''));
            var len = binary.length;
            var buffer = new ArrayBuffer(len);
            var view = new Uint8Array(buffer);
            for (var i = 0; i < len; i++) {
                view[i] = binary.charCodeAt(i);
            }

            this.documentDataURL = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(new Blob([view], { type: "application/pdf" })));
            this.viewingDocument = true;
         //   window.open(this.document);
        });
    }
    trainingSaved(data: any, note: PersonTrainingBus) {
        let user = this.globals.user;
        console.log("saved: ", data);

        if (this.files && this.files.length) {
            this.svc_data.uploadAttachment(this.files, data.personTrainingId).subscribe(
                data => this.attachmentSaved(data),
                err => { this.CallFailed(err) });
        }
        else {
            this.saveSuccess();
            this.LoadTraining();}
    }

    public LoadTraining() {
        if (this.personId == '00000000-0000-0000-0000-000000000000') { return; }
        this.svc_data.getPersonTraining(this.personId).subscribe(
            data => this.retrieveTrainingSuccess(data),
            err => { this.CallFailed(err) });
    }

    retrieveTrainingSuccess(data: any) {
        console.log("training data retrieved: ", data);
        this.svc_data.EmployeeTrainingData = data;
    }

    attachmentSaved(data: any) {
        this.saveSuccess();
        this.LoadTraining();
    }
    CallFailed(err) {
        console.log("error: ", err);
        this.saveError(err);
    }

    files: Array<FileInfo> = [];
    uploadSaveUrl: string = "http://localhost:53158/api/media/upload";//"http://18.188.111.206/api/media/upload";
    uploadRemoveUrl: string;
    uploadRestrictions: any;

    selectEventHandler(e: any) {
        this.files = e.files;
    }
    clearEventHandler(e: any) {

    }
    removeEventHandler(e: any) {

    }
    completeEventHandler(e: any) {

    }
}
